module.exports = __webpack_public_path__ + "img/ralf_thoma.a8cfaf7b.png";